import React from 'react';
import styled from 'styled-components';
import { HorizontalContent } from '../HorizontalContent';
import { RhCard } from '../RhCard';
import { RhInput, RhInputMode } from '../RhInput';
import { RhTag } from '../RhTag';
import { SizedBox } from '../SizedBox';
import { H2 } from '../Styles';

type Props = {
  /** the current form state */
  form: { tag: string; tags: string[] };
  /** user wants to add a tag to tags */
  userPushedToTags: () => void;
  /** called when the user edits the fields */
  userUpdatedForm: (formState: { tag: string; tags: string[] }) => void;
};

export const TagsCard: React.FC<Props> = props => {
  return (
    <RhCard mode="tiled">
      <HorizontalContent left={<H2>Tags</H2>} />
      <SizedBox height={12} />
      <RhInput
        mode={RhInputMode.subtle}
        placeholder="Type a tag..."
        containerStyle={{ width: '100%' }}
        value={props.form.tag}
        onKeyUp={e => {
          if (e.key === 'Enter') {
            props.userPushedToTags();
          }
        }}
        onChange={e =>
          props.userUpdatedForm({
            ...props.form,
            tag: e.target.value,
          })
        }
      />
      {!!props.form.tags.length && (
        <Tags>
          {props.form.tags.map((currentTag, i) => (
            <RhTag
              className="p-1"
              key={currentTag + i}
              title={currentTag}
              onPressX={() =>
                // update form => tags without current tag
                props.userUpdatedForm({
                  ...props.form,
                  tags: props.form.tags.filter(tag => currentTag !== tag),
                })
              }
            />
          ))}
        </Tags>
      )}
    </RhCard>
  );
};

const Tags = styled.div`
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  & > * {
    margin-right: 8px;
    margin-bottom: 8px;
  }
`;
